'use strict';

angular.module('far.project').controller('ProjectReportController', function ($rootScope, $window, projectReportForm, Project, ProjectReport, $scope, FileUploader) {
    var vm = {
        progress: true,
        submitted: false,
        form: {},
        event: {},
        requestController: {},
        users: [],
        fields: projectReportForm,
        eventType: null,
        eventUserTypes: {},
        init: function (eventId, eventReportEdit) {
            if (eventReportEdit) {
                vm.form = ProjectReport.get(eventId, vm.eventUserTypes, function () {
                    if (vm.form.documents_files.length > 0) {
                        vm.form.documents_files.forEach(function (serverFile) {
                            var newFile = new FileUploader.FileItem(vm.fields.$fields.documentsFiles.uploader, {
                                lastModifiedDate: new Date(),
                                size: 1e6,
                                name: serverFile.original_name
                            });

                            newFile.progress = 100;
                            newFile.isUploaded = true;
                            newFile.isSuccess = true;
                            newFile.serverData = angular.merge({}, serverFile);

                            vm.fields.$fields.documentsFiles.uploader.queue.push(newFile);
                        });
                    }

                    vm.progress = false;
                });
            } else {
                vm.form = ProjectReport.new({
                    event_id: eventId
                }, vm.eventUserTypes);

                var usersWatch = $rootScope.$watch(function () {
                    return vm.requestController.users.length;
                }, function (length) {
                    if (length > 0) {
                        vm.requestController.users.forEach(function (value) {
                            var user = vm.form.createUser(vm.form.userTypes.user_participant);

                            vm.form.updateUser(user.uniqId, value);
                        });

                        usersWatch();
                    }
                });

                vm.progress = false;
            }
        },
        sendReport: function () {
            vm.form.submitted = true;
            vm.form.accepted = false;

            vm.save();
        },
        sendAccepted: function () {
            vm.form.submitted = true;
            vm.form.accepted = true;

            vm.save();
        },
        setUsers: function (users) {

        },
        save: function () {
            if (vm.progress || $scope.projectReportForm.$invalid) {
                return;
            }

            vm.form.documents_files = vm.documents_files;

            vm.form.event = vm.requestController.getEventData();

            vm.form.save()
                .then(function (response) {
                    $window.location.href = Routing.generate('event_view', {id: response.data.id});
                }, function (response) {

                });
        }
    };

    vm.fields.$fields.users.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.updateUser(options.index, item);
    };

    return vm;
});
